import { createTheme } from "@mui/material/styles";
import colors from "./colors";
import typography from "./typography";
import components from "./components";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: colors.primary,
    secondary: colors.secondary,
    background: colors.background,
    text: colors.text,
    divider: colors.border.divider,
    grey: colors.gray,
    success: { main: colors.success },
    error: { main: colors.error },
    warning: { main: colors.warning },
    info: { main: colors.info },
    common: colors.common,
  },
  typography,
  components,
  // Expose custom tokens so components can use theme.custom.*
  custom: {
    border: colors.border,
    input: colors.input,
    surface: colors.background,
    highlight: colors.highlight,
    extra: colors.extra,
  },
});

export default theme;
